<template>
  <div>
      <div id="box">
        <v-row class="row pa-2">
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <div id="title" :style="{'color':theme}">                  
            {{title}}
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.CampaignId"
              item-value="id" 
              item-text="name"
              :items="filterCampaigns"
              label="Campaign Filter"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.UserId"
              item-value="id" 
              item-text="name"
              :items="filterUsers"
              :label="filterUserLabel"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-menu
              ref="monthPicker"
              v-model="monthPicker"
              :close-on-content-click="false"
              :return-value.sync="selectedMonth"
              transition="scale-transition"
              offset-y
              dense
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field                
                  label="Year Month"
                  v-model="searchMonth"                
                  readonly    
                  clearable            
                  outlined
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @change="search()"           
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchMonth"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="secondary"
                    @click="monthPicker = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="secondary"
                    @click="searchMonthOk"
                >
                    OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-divider ></v-divider>
        <v-row class="mg-top-0">
            <v-col cols="12" class="pd-top-0">
                <v-container class="pd-top-0">                    
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :items-per-page="5"
                        class="elevation-1"
                        :key="dataTableKey"
                    >
                    <template v-slot:[`item.vertical`]="{ item }">
                        <v-chip class="ma-1" color="primary" small text-color="white" v-for="(v, index) in item.vertical" :key="index">
                          <span>{{v.name}}</span>
                        </v-chip>
                    </template>
                    </v-data-table>             
                </v-container>
            </v-col>
        </v-row>
      </div>          
  </div>
</template>
<script>
// import paymentAPIs from './clientAPIs'

export default {
  name: 'ClientQualityRating',
  props: {
    theme: {type: String},
    title: {type: String},
    headers: {type: Array},
    items: {type: Array},
    filterCampaigns: {type: Array},
    filterUsers: {type: Array},
    filterUserLabel: {type: String}
  },
  data: () => ({
    selectedFilter: {CampaignId: '', UserId: ''},
    itemArray: [],
    seeMoreDialog: false,
    searchMonth: '',
    selectedMonth: '',
    monthPicker: false,
    dataTableKey: 0
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    search() {
      let filter = Object.assign({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter)
    },
    searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    }
  }
}
</script>
<style scoped>
.mg-top-0 {
  margin-top: 0px !important;
}

.mg-bottom-0 {
  margin-bottom: 0px !important;
}

.mg-bottom-10 {
  margin-bottom: 10px !important;
}

.pd-bottom-0 {
  padding-bottom: 0px !important;
}

.pd-top-0 {
  padding-top: 0px !important;
}

.filter-pad {
    padding:10px 0 0px 10px;
}

#box {
  /* width: 366px; */
  /* min-height: 430px; */

  border: 0.8px solid #E5E5E5;
  box-sizing: border-box;
}

#title {
  /* width: 366px; */
  height: 46px;

  font-family: WorkSans-Medium;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 45px;
  
  padding-left:17px;
  padding-top:5px;
}

#avg {
  padding-top:10px;
  /* height: 28px; */
  left: calc(50% - 304px/2 - 1px);
  top: calc(50% - 28px/2 - 7.5px);

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

#avgTitle {
  /* width: 309px; */
  height: 12px;
  left: calc(50% - 309px/2 - 3.5px);
  top: calc(50% - 12px/2 + 18.5px);
  padding-top:5px;

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
/* identical to box height */

  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

.left-div-border {
  border-left: 4px solid;
  height: 35px;
  width: 4px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// ClientQualityRating.vue?3dc012ea